module.exports = __webpack_public_path__ + "static/new-machine-a448935e8c5c40a7d4137296cf76a49e.png";